<style>
    .vs-card--content {
        margin-bottom: 0;
    }

    .vs-con-textarea {
        margin-bottom: 0;
    }

    .vx-input-group .vx-input-group-default:not(:last-child) input {
        border-right-color: rgba(0, 0, 0, 0) !important;
    }
</style>

<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Stock Check Details</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" icon="save">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Reference*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.reference" />
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Check Date*
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.check_date" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Client ID*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-2"
                                    v-model="data.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Warehouse ID*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-2"
                                    v-model="data.warehouse_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, warehouse)"
                                >
                                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Item Details">
                        <vs-button type="border" class="btn mr-1 mt-5" :disabled="!data.warehouse_id || !data.client_id" @click="getData">Refresh</vs-button>
                        <vs-button type="border" class="btn mr-1 mt-5" :disabled="!data.warehouse_id || !data.client_id" @click="params.show = true; old_params = JSON.parse(JSON.stringify(data))">Params</vs-button>
                        <div style="max-height: 400px; overflow: auto;" class="mt-5">
                            <vs-table :data="data.details" hoverFlat class="mt-5" stripe>
                                <template slot="thead">
                                    <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                                    <vs-th style="min-width: 150px;">Location Type</vs-th>
                                    <vs-th style="min-width: 200px;">Location ID</vs-th>
                                    <vs-th style="min-width: 200px;">Product ID</vs-th>
                                    <vs-th style="min-width: 200px;">Description</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Base UoM</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Pick Qty</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Put Qty</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data" >
                                        <vs-td>{{ index + 1 }}</vs-td>
                                        <vs-td>{{ tr.location_type }}</vs-td>
                                        <vs-td>{{ tr.location_code }}</vs-td>
                                        <vs-td>{{ tr.product_code }}</vs-td>
                                        <vs-td>{{ tr.description }}</vs-td>
                                        <vs-td>{{ tr.pack_id }}</vs-td>
                                        <vs-td>{{ tr.batch }}</vs-td>
                                        <vs-td>{{ tr.expired_date }}</vs-td>
                                        <vs-td>{{ tr.base_qty }}</vs-td>
                                        <vs-td>{{ tr.base_uom }}</vs-td>
                                        <vs-td>{{ tr.stock_type }}</vs-td>
                                        <vs-td>{{ tr.pick_qty }}</vs-td>
                                        <vs-td>{{ tr.put_qty }}</vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </vs-tab>
                    <vs-tab label="Notes">
                        <vs-textarea height="200" class="mt-5" label="Notes"/>
                    </vs-tab>
                    <vs-tab label="Attachment">
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>

        <!-- Popup Params -->
        <vs-prompt
            title="Parameters"
            :active.sync="params.show"
            @accept="getData"
            @close="data = JSON.parse(JSON.stringify(old_params)); params.show = false"
            @cancel="data = JSON.parse(JSON.stringify(old_params)); params.show = false"
        >
            <div class="vx-row mt-6">
                <div class="vx-col w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Location Type
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vs-select
                                    class="selectExample mb-2"
                                    v-model="data.location_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, location_type)"
                                >
                                    <vs-select-item v-for="(item, index) in location_type.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Location ID
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vs-select
                                    class="selectExample mb-2"
                                    v-model="data.location_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, location)"
                                >
                                    <vs-select-item v-for="(item, index) in location.data" :key="index" :value="item.id" :text="item.location_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-checkbox v-model="data.include_empty" style="margin-left: -1px">Include Empty Locations</vs-checkbox>
                        </div>
                    </div> -->
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Product ID
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vs-select
                                    class="selectExample mb-2"
                                    v-model="data.product_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, product)"
                                >
                                    <vs-select-item v-for="(item, index) in product.data" :key="index" :value="item.id" :text="item.product_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Pack ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.pack_id" />
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Batch
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.batch" />
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Stock Type
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vs-select
                                    class="selectExample mb-2"
                                    v-model="data.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, stock_type)"
                                >
                                    <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                isLoading: false,
                detailsCount: 0,
                data: {
                    reference: '',
                    check_date: new Date(),
                    warehouse_id: null,
                    client_id: null,
                    details: [],
                    location_type_id: null,
                    location_id: null,
                    product_id: null,
                    pack_id: null,
                    batch: null,
                    stock_type_id: null,
                    include_empty: false
                },
                params: {
                    show: false,
                    location_type: '',
                    location_type_id: null,
                    location_code: '',
                    location_id: null,
                    product_code: '',
                    product_id: null,
                    stock_type: '',
                    stock_type_id: null,
                    include_empty: 0,
                    pack_id: '',
                    batch: '',
                },
                old_params: {},
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                warehouse: {
                    data: [],
                    loading: false,
                    endpoint: 'master/warehouses',
                    objectKey: 'warehouses_code'
                },
                location_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/locationtypes',
                    objectKey: 'name'
                },
                location: {
                    data: [],
                    loading: false,
                    endpoint: 'master/locations',
                    objectKey: 'location_code'
                },
                product: {
                    data: [],
                    loading: false,
                    endpoint: 'master/product',
                    objectKey: 'product_code'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes',
                    objectKey: 'name'
                },
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            submitForm() {
                let error = false
                if(!this.data.reference) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "Reference is required."
                    });

                    error = true
                }

                if(!this.data.check_date) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "Check date is required."
                    });

                    error = true
                }

                if(this.data.details.length < 1) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "Detail is empty."
                    });

                    error = true
                }

                if(error) {
                    return false
                }

                const ids = this.data.details.map(item => {
                    return item.id
                })

                const data = {
                    client_id: this.data.client_id,
                    warehouse_id: this.data.warehouse_id,
                    reference: this.data.reference,
                    check_date: this.data.check_date,
                    location_type_id: this.params.location_type_id,
                    location_id: this.params.location_id,
                    product_id: this.params.product_id,
                    stock_type_id: this.params.stock_type_id,
                    include_empty: this.params.include_empty,
                    pack_id: this.params.pack_id,
                    batch: this.params.batch,
                    details: this.data.details.map(item => {
                        return {
                            location_id: item.location_id,
                            product_id: item.product_id,
                            pack_id: item.pack_id,
                            expired_date: item.expired_date,
                            base_qty: item.base_qty,
                            batch: item.batch,
                            base_uom_id: item.base_uom_id,
                            stock_type_id: item.stock_type_id,
                            pick_qty: item.pick_qty,
                            put_qty: item.put_qty
                        }
                    })
                }
                this.isLoading = true
                this.$http.post('inventories/stockcheck/add', data)
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: res.data.message
                    });

                    this.$router.push({
                        name: 'stock-check'
                    })
                })
                .catch(error => this.handleError(error))
            },
            back() {
                this.$router.push({name: 'stock-check'})
            },
            fetchData() {
                this.isLoading = true
                Promise.all([
                    this.$http.post('master/clients'),
                    this.$http.post('master/warehouses'),
                    this.$http.post('master/locationtypes'),
                    this.$http.post('master/product'),
                    this.$http.post('master/stocktypes')
                ])
                .then(this.$http.spread((clients, warehouses, locationtypes, products, stocktypes) => {
                    this.isLoading = false
                    this.client.data = clients.data.data
                    this.warehouse.data = warehouses.data.data
                    this.location_type.data = locationtypes.data.data
                    this.product.data = products.data.data
                    this.stock_type.data = stocktypes.data.data

                    this.stock_type.data.unshift({id: null, name: 'Any'})
                    this.location_type.data.unshift({id: null, name: 'Any'})
                    this.location.data.unshift({id: null, location_code: 'Any'})
                    this.product.data.unshift({id: null, product_code: 'Any'})
                }))
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchData()
                        },
                        cancel: () => this.$router.push({name: 'stock-check'}),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                })
            },
            getData() {
                const data = {
                    client_id: this.data.client_id,
                    warehouse_id: this.data.warehouse_id,
                    location_id: this.data.location_id,
                    location_type_id: this.data.location_type_id,
                    product_id: this.data.product_id,
                    stock_type_id: this.data.stock_type_id,
                    include_empty: this.data.include_empty,
                    pack_id: this.data.pack_id,
                    batch: this.data.batch,
                }

                this.data.details = []

                this.isLoading = true
                this.$http.post('inventories/stockcheck/getdetails', data)
                .then(res => {
                    this.isLoading = false
                    this.data.details = res.data
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.isLoading = false;
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: message
                    });
                })
            },
            searchParams() {
                this.params.show = false
                this.isLoading = true
                this.$http.post('inventories/stockcheck/getparams', this.params)
                .then(res => {
                    this.isLoading = false
                    this.params.show = false
                    this.params.location_id = res.data.location_id ? res.data.location_id : null
                    this.params.location_type_id = res.data.location_type_id ? res.data.location_type_id : null
                    this.params.product_id = res.data.product_id ? res.data.product_id : null
                    this.params.stock_type_id = res.data.stock_type_id ? res.data.stock_type_id : null

                    this.getData()
                })
                .catch(error => {
                    this.isLoading = false
                    error.response.data.message.map(message => {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            iconPack: "feather",
                            icon: "icon-x",
                            text: message
                        });
                    })
                })
            }
        },
        mounted(){
            this.fetchData()
        },
	}
</script>